// extracted by mini-css-extract-plugin
module.exports = {"category":"category__2AoAle_96FCn","category_name":"category_name__1hcoomO1Rkl4","category_replies":"category_replies__yaRK2XqXXAzP"};